import { Form, Input, Button, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import '../index.css';
import { enmValidationLevel, ICallOptions } from '../../components/infrastructure/models';
import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Core } from '../../components/infrastructure/core';
import { Captcha } from '../../components/captcha/index';
import AppContext from '../../components/infrastructure/appContext';

interface ILoginState {
    success?: boolean;
    loading?: boolean;
    resetPassword?: boolean;
    firstLogin?: boolean;
    userName?: string;
}

const UserLogin = () => {
    const { params } = React.useContext(AppContext);
    const [state, setState] = React.useState<ILoginState>({ success: false, userName: params['username'] ?? '' });
    const [form] = Form.useForm();

    const componentWillUnmount = React.useRef(false);

    const onFinish = async (values: any) => {
        if (state.loading)
            return;

        setState({ ...state, loading: true });

        let opts: ICallOptions = {
            url: "user/login",
            data: {
                userName: values['username'],
                password: values['password'],
                rememberMe: values['remember'],
                captcha: values['captcha']
            },
            headers: [{
                key: 'content-type', value: 'application/json;charset=UTF-8'
            }],
            onComplete: () => {
                if (componentWillUnmount.current)
                    return;
                setState({ ...state, loading: false });
            },
            onSuccess: result => {
                if (componentWillUnmount.current)
                    return;

                if (!result.ValidationState.Successful) {
                    Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
                    setState({ ...state, loading: false });
                }
                else {
                    if (result.ValidationState.ValidationResults.length) {
                        Core.successNotification(result.ValidationState.ValidationResults[0].Message);
                        if (result.ValidationState.ValidationResults[0].Level === enmValidationLevel.ResetPassword) {
                            setState({ ...state, loading: false, resetPassword: true });
                            return;
                        }
                        else if (result.ValidationState.ValidationResults[0].Level === enmValidationLevel.FirstLogin) {
                            setState({ ...state, loading: false, firstLogin: true });
                            return;
                        }
                    }
                    else {
                        Core.successNotification('خوش آمدید');
                        setState({ ...state, success: true });
                    }
                }
            }
        };

        await Core.callApi(opts);
    };

    React.useEffect(() => {
        return () => {
            componentWillUnmount.current = true;
        };
    }, []);

    if (state.success) {
        let returnUrl = '/';
        if (params["returnurl"] && params["returnurl"] !== '/logout')
            returnUrl = decodeURIComponent(params["returnurl"]);
        const split = returnUrl.split('?');
        return <Redirect to={{ pathname: split[0], search: split.length > 1 ? '?' + split[1] : '' }} />
    }

    if (state.resetPassword) {
        return <Redirect to={"/resetpassword"} />
    }

    if (state.firstLogin) {
        return <Redirect to={"/resetpassword?username=" + form.getFieldValue("username") + "&code=" + form.getFieldValue("password")} />
    }

    return (
        <>
            <div className="box box-blue" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                <img src={'/userlogo.png'} style={{ marginTop: 20, width: 80 }} alt="" />
                <p className="" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 18, fontWeight: "bold", color: "antiquewhite" }}>ورود کاربران ستادی</p>
            </div>
            <Form
                form={form}
                //labelCol={{ span: 6 }}
                wrapperCol={{ span: 24 }}
                name="normal_login"
                className="box login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50, paddingTop: 5, border: "1px solid white", backgroundColor: "#fefefe90", borderBottomLeftRadius: 15, borderBottomRightRadius: 15, width: "100%", textAlign: "right" }}
            >
                <Form.Item
                    name="username"
                    //label="نام کاربری"
                    rules={[
                        { required: true, message: 'لطفا نام کاربری را وارد نمایید' },
                        {
                            required: true,
                            validator: () => {
                                const userName = form.getFieldValue('username');
                                if (Core.isNationalCode(userName))
                                    return Promise.reject(new Error('نام کاربری نمیتواند کد ملی باشد'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                    initialValue={state.userName}
                >
                    <Input
                        autoComplete="off"
                        prefix={<UserOutlined className="site-form-item-icon" />}
                        placeholder="نام کاربری"
                        style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                   // label="کلمه عبور"
                    name="password"
                    rules={[{ required: true, message: 'لطفا کلمه عبور را وارد نمایید' }]}
                >
                    <Input
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="کلمه عبور"
                        autoComplete="off"
                        style={{ width: "100%" }}
                    />
                </Form.Item>

                {!state.loading &&
                    <Captcha
                        form={form}
                        name="captcha"
                        label="متن تصویر"
                    />
                }

                <Form.Item
                    name="remember"
                    valuePropName="checked"
                    style={{ textAlign: 'right', marginTop: 15, marginBottom: 15 }}
                >
                    <Checkbox >به خاطر بسپار </Checkbox>
                </Form.Item>

                <Form.Item style={{ direction: 'ltr', textAlign: 'justify' }}>
                    <Button type="primary" htmlType="submit" className="login-form-button" loading={state.loading}>
                        ورود
                    </Button>
                    <Link className="login-form-forgot" to={{ pathname: '/forgetpassword' }} style={{ marginLeft: 10 }}> بازنشانی کلمه عبور</Link>
                </Form.Item>
            </Form>
        </>
    );
};

export default UserLogin;